import React from "react";
import PropTypes from "prop-types";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "./styles.scss";

const Tags = ({ data }) => {
    return (
        <div className={`tag-wrapper ${data.status} ${data.disabled ? 'disabled' : ''}`}>
            <div className="tag-content">
                {}
                {data.status === "completed" ? (
                    <>
                        <FaCheckCircle className="icon" />
                        <span className="text">Completed</span>
                    </>
                ) : (
                    <>
                        <FaTimesCircle className="icon" />
                        <span className="text">Not complete</span>
                    </>
                )}
            </div>
        </div>
    );
};

Tags.propTypes = {
    data: PropTypes.shape({
        status: PropTypes.oneOf(["completed", "not-complete"]).isRequired,
        disabled: PropTypes.bool,
    }),
};

Tags.defaultProps = {
    data: {
        status: "not-complete",
        disabled: false,
    },
};

export default Tags;
